import React, { useEffect } from "react"
import { Gesture, GestureDetector } from "react-native-gesture-handler"
import Animated, {
    runOnJS,
    useAnimatedStyle,
    useSharedValue,
    withSpring,
    withTiming,
} from "react-native-reanimated"
import { useSafeAreaFrame, useSafeAreaInsets } from "react-native-safe-area-context"
import { IS_WEB } from "@common/utils/mobileUtils"
import { useWindowDimensions } from "react-native"

const DraggableView = ({
    children,
    minHeight = 0,
    minWidth = 0,
    contentWidth = 0,
    contentHeight = 0,
    initValue = { x: 0, y: 0 },
    onRelease = () => {},
    onStart = () => {},
    onActive = () => {},
    style,
    isDraggable = true,
    onlyFirstDrag = false,
    maxHeight = 0,
                           maxWidth = 0,
}) => {
    const insets = useSafeAreaInsets()
    const minWidthWithInsets = minWidth + insets.left + 5
    const minHeightWithInsets = minHeight + insets.top + 5
    const maxWidthWithInsets = maxWidth + insets.left - 5
    const maxHeightWithInsets = maxHeight + insets.top - 5

    const x = useSharedValue(initValue.x || 0)
    const y = useSharedValue(initValue.y || 0)

    const startX = useSharedValue(initValue.x || 0)
    const startY = useSharedValue(initValue.y || 0)

    const panGesture = Gesture.Pan()
        ?.onStart(() => {
            'worklet'
            startX.value = x.value
            startY.value = y.value

            runOnJS(onStart)()
        })
        ?.onUpdate((event) => {
            'worklet'
            // Update the position based on the initial position and translation
            const endX = startX.value + event.translationX
            const endY = startY.value + event.translationY
            x.value = endX
            y.value = endY
            runOnJS(onActive)({ x: endX, y: endY })
        })
        ?.onEnd(() => {
            'worklet'
            let finalX = x.value
            let finalY = y.value

            if (finalY < minHeightWithInsets) {
                finalY = minHeightWithInsets
                y.value = withSpring(minHeightWithInsets)
            }
            if (finalY + contentHeight > maxHeightWithInsets) {
                finalY = maxHeightWithInsets - contentHeight
                y.value = withSpring(maxHeightWithInsets - contentHeight)
            }
            if (finalX < minWidthWithInsets) {
                finalX = minWidthWithInsets
                x.value = withSpring(minWidthWithInsets)
            }
            if (finalX + contentWidth > maxWidthWithInsets) {
                finalX = maxWidthWithInsets - contentWidth
                x.value = withSpring(maxWidthWithInsets - contentWidth)
            }

            startX.value = finalX
            startY.value = finalY

            runOnJS(onRelease)({ x: finalX, y: finalY })
        })
        .enabled(isDraggable)

    const animatedStyle = useAnimatedStyle(() => {
        return {
            transform: [
                {
                    translateX: x.value,
                },
                { translateY: y.value },
            ],
        }
    })

    useEffect(() => {
        if (isDraggable || onlyFirstDrag) {
            x.value = withTiming(initValue.x)
            y.value = withTiming(initValue.y)

            startX.value = initValue.x
            startY.value = initValue.y
        } else {
            x.value = withTiming(0)
            y.value = withTiming(0)

            startX.value = 0
            startY.value = 0
        }
    }, [isDraggable, initValue.x, initValue.y])

    return (
        <GestureDetector gesture={panGesture}>
            <Animated.View style={[animatedStyle, style]}>
                {children}
            </Animated.View>
        </GestureDetector>
    )
}

export default DraggableView
